import { View } from 'react-native'

import { styled } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineThreepulse,

      padding: theme.paddingInsetThreepulse,

      borderTopWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorBorderNeutralDefault,

      backgroundColor: theme.colorFillNeutralDefault,
    },
    variants: {},
  }
})
